const BACKEND_URL = process.env.REACT_APP_BACKEND_BASE_URL;

export const getCheckoutUrl = (userId: string) => `${BACKEND_URL}/billing/checkout?userId=${userId}`;
export const getCancelUrl = (customerId: string) => `${BACKEND_URL}/billing/cancel?customerId=${customerId}`;
export const getPortalUrl = (customerId: string) => `${BACKEND_URL}/billing/portal?customerId=${customerId}`;

export const sendIntroEmail = async (userId: string) => {
    const res = await fetch(`${BACKEND_URL}/billing/intro-email`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify({userId}), // body data type must match "Content-Type" header
    });
    return res;
};
